import { createAsyncThunk } from '@reduxjs/toolkit';
import { Slider, AllSlider } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchSlider, FindSlider, GetSlider } from './interface';

export const findSlider = createAsyncThunk(
  'slider/findSlider',
  async (values: FindSlider, { rejectWithValue }) => {
    try {
      const response = await AllSlider.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createSlider = createAsyncThunk(
  'slider/createSlider',
  async (values: CreatePatchSlider, { rejectWithValue }) => {
    try {
      const response = await Slider.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchSlider = createAsyncThunk(
  'slider/patchSlider',
  async ({ id, ...values }: CreatePatchSlider, { rejectWithValue }) => {
    try {
      const response = await Slider.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSlider = createAsyncThunk(
  'slider/getSlider',
  async ({ id }: GetSlider, { rejectWithValue }) => {
    try {
      const response = await Slider.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);